import { ChartOptions, ChartType } from 'chart.js';
import { Color, Label, SingleDataSet } from 'ng2-charts';

export class Piecharts {
    pieChartColors: Color[]; // ['red', '#00B359', 'rgba(148,159,177,0.2)']
    pieChartLabels: Label[]; // [['Download', 'Sales'], ['In', 'Store', 'Sales'], 'Mail Sales']
    pieChartData: SingleDataSet; // [300, 500, 100]
    pieChartType: ChartType;
    pieChartLegend = true;
    pieChartPlugins = [];
    pieChartOptions: ChartOptions;

    constructor(chartType: ChartType, showLegend?: boolean) {
        this.pieChartType = chartType;
        if (showLegend !== undefined) {
            this.pieChartLegend = showLegend;
        }
        this.pieChartOptions = {
            responsive: true,
            legend: { position: 'right' }
        };
    }
}
